// export const geoApiOptions = {
// 	method: 'GET',
// 	headers: {
// 		'X-RapidAPI-Key': '48b3d65f9amshc48aa42b58eb01bp11c105jsn29653c059ea1',
// 		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
// 	}
// };

// export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo"
export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '48b3d65f9amshc48aa42b58eb01bp11c105jsn29653c059ea1',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5/'

export const WEATHER_API_KEY = '73c586955508127ab2f58bebcdde7863'
